export interface AnimeCharacter {
  name: string;
  cv: string;
  role: string;
}

export interface Anime {
  id: string;
  title: string;
  cover: string;
  banner: string;
  synopsis: string;
  story: string;
  director: string;
  types: string[];
  year: string;
  region: string;
  episodes: number;
  rating?: number;
  status: string;
  tags: string[];
  characters: AnimeCharacter[];
  newsIds: string[];
}

export const animeList: Anime[] = [
  {
    id: "a01",
    title: "星海列车",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20digital%20illustration%20of%20a%20gleaming%20interstellar%20train%20gliding%20through%20a%20nebula%20of%20orange%20and%20violet%20stardust%2C%20young%20female%20conductor%20in%20a%20navy%20uniform%20standing%20on%20the%20observation%20deck%2C%20cel-shaded%20shading%2C%20dramatic%20rim%20light%2C%20poster%20composition%2C%20clean%20simple%20dark%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=anime-cover-01&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20style%20cinematic%20wide%20illustration%20of%20a%20silver%20interstellar%20steam%20train%20flying%20across%20a%20deep%20indigo%20galaxy%20filled%20with%20glowing%20orange%20comets%20and%20soft%20nebula%20clouds%2C%20tiny%20silhouette%20of%20a%20girl%20on%20the%20roof%2C%20cel-shaded%2C%20volumetric%20light%2C%20epic%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1600&height=760&seq=anime-hero-01&orientation=landscape",
    synopsis:
      "一趟穿越星海的列车，载着失去故乡的少女与人造的旅伴，驶向传说中能实现愿望的终点站。",
    story:
      "在星际殖民时代末期，负责运送亡者记忆的“星海列车”即将停运。见习列车员苍井零在一次意外中接手了最后一班列车，车上的乘客都是无法回到故乡的灵魂。为了完成他们的心愿，零与机械副手阿铁一同穿越陨石带、废弃空间站与沉默的星球，在旅途中逐渐找回自己被抹去的记忆。作品以温柔的笔触描绘告别与重逢，用每一站的故事拼出关于家的答案。",
    director: "早濑川彻",
    types: ["科幻", "治愈", "冒险"],
    year: "2025",
    region: "日本",
    episodes: 12,
    rating: 9.2,
    status: "已完结",
    tags: ["科幻", "治愈", "旅行", "太空"],
    characters: [
      { name: "苍井零", cv: "水濑结衣", role: "主角 / 见习列车员" },
      { name: "阿铁", cv: "黑木刚", role: "机械副手" },
      { name: "千夜", cv: "白石真冬", role: "神秘乘客" },
    ],
    newsIds: ["n01", "n05"],
  },
  {
    id: "a02",
    title: "剑与蔷薇的誓约",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20digital%20illustration%20of%20a%20young%20female%20knight%20in%20polished%20silver%20armor%20holding%20a%20glowing%20longsword%2C%20red%20roses%20blooming%20around%20her%20feet%2C%20warm%20sunset%20backlight%2C%20cel-shaded%20shading%2C%20regal%20fantasy%20poster%20composition%2C%20clean%20simple%20cream%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=anime-cover-02&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20style%20cinematic%20wide%20fantasy%20illustration%20of%20an%20armored%20knight%20facing%20a%20vast%20castle%20courtyard%20filled%20with%20red%20rose%20vines%20and%20golden%20sunbeams%2C%20banners%20fluttering%2C%20cel-shaded%2C%20epic%20warm%20lighting%2C%20high%20detail%2C%20no%20text&width=1600&height=760&seq=anime-hero-02&orientation=landscape",
    synopsis:
      "没落骑士家族的女儿与一朵会说话的蔷薇缔结契约，为夺回被夺走的王国踏上征程。",
    story:
      "蔷薇王国在一夜之间失去了王座，骑士少女莉泽尔的家族被诬陷为叛徒。流亡途中，她在废弃花园里遇见了封印着古王灵魂的蔷薇。为了洗清冤屈、也为了履行先祖的誓约，莉泽尔佩剑上路，与赏金猎人、流亡学者和敌国的叛将组成临时同盟。剑光与花香交织的旅途中，她逐渐明白真正的荣耀不在王座，而在守护他人时的那份坚定。",
    director: "桐生雅人",
    types: ["奇幻", "热血", "剧情"],
    year: "2024",
    region: "日本",
    episodes: 24,
    rating: 8.9,
    status: "连载中",
    tags: ["奇幻", "骑士", "冒险", "成长"],
    characters: [
      { name: "莉泽尔", cv: "高桥遥", role: "主角 / 骑士" },
      { name: "蔷薇之灵", cv: "绪方千夏", role: "古王灵魂" },
      { name: "加雷斯", cv: "森田健", role: "赏金猎人" },
    ],
    newsIds: ["n03", "n08"],
  },
  {
    id: "a03",
    title: "都市灵能档案",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20digital%20illustration%20of%20a%20young%20man%20in%20a%20dark%20long%20coat%20surrounded%20by%20glowing%20cyan%20spirit%20glyphs%20in%20a%20rainy%20neon%20city%20alley%2C%20moody%20night%20lighting%2C%20cel-shaded%2C%20supernatural%20poster%20composition%2C%20simple%20dark%20teal%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=anime-cover-03&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20style%20cinematic%20wide%20illustration%20of%20a%20rain%20soaked%20modern%20city%20street%20at%20night%20lit%20by%20cyan%20and%20amber%20signs%2C%20floating%20glowing%20spirit%20glyphs%20in%20the%20air%2C%20lone%20figure%20in%20a%20coat%2C%20cel-shaded%2C%20moody%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1600&height=760&seq=anime-hero-03&orientation=landscape",
    synopsis:
      "在普通人看不见的城市夹层里，灵能调查员记录着每一桩无法解释的都市传说。",
    story:
      "现代都市的表面之下，存在着由怨念与执念构成的“夹层”。灵能调查员叶决受雇于半官方的档案局，专门处理那些警方无法立案的怪异事件。他和搭档——能听见器物心声的少女苏茗——逐一调查地铁末班车的乘客失踪案、会自行生长的老楼、以及只在雨夜出现的琴声。每个案子背后，都是一段被时代遗忘的人在求救。",
    director: "神谷陆",
    types: ["悬疑", "奇幻", "剧情"],
    year: "2025",
    region: "国内",
    episodes: 16,
    rating: 8.6,
    status: "连载中",
    tags: ["悬疑", "都市", "灵异", "推理"],
    characters: [
      { name: "叶决", cv: "顾言", role: "主角 / 灵能调查员" },
      { name: "苏茗", cv: "林小满", role: "搭档" },
      { name: "老周", cv: "周立群", role: "档案局局长" },
    ],
    newsIds: ["n02", "n07"],
  },
  {
    id: "a04",
    title: "猫町奇谭",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20digital%20illustration%20of%20a%20sunny%20whimsical%20town%20inhabited%20by%20charming%20cats%20wearing%20tiny%20hats%20and%20aprons%2C%20a%20girl%20kneeling%20to%20greet%20them%20in%20a%20flowered%20lane%2C%20soft%20warm%20pastel%20palette%2C%20cel-shaded%2C%20storybook%20poster%20composition%2C%20simple%20pale%20cream%20background%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=anime-cover-04&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20cozy%20pastel%20cat%20town%20with%20warm%20lanterns%2C%20tiled%20rooftops%20and%20blooming%20flower%20stalls%2C%20many%20stylized%20cats%20strolling%2C%20golden%20afternoon%20light%2C%20cel-shaded%2C%20high%20detail%2C%20no%20text&width=1600&height=760&seq=anime-hero-04&orientation=landscape",
    synopsis:
      "迷路的人类少女误入只有猫居住的小镇，用人类的善意换来了这座小镇的秘密。",
    story:
      "暑假第一天，转学生小满在旧巷尽头发现了一扇只有她能推开的门。门后是猫町——一座由猫经营的小镇，面包店、钟表行、邮局里都是会说话的猫。为了回到现实世界，小满必须在天亮前帮镇长找回遗失的铃铛。她与懒散的邮差猫三花、爱吹牛的钟表匠老黑结伴，穿越屋顶与地窖，在笑声与温情中理解了“家”对一个流浪者的意义。",
    director: "南野绫",
    types: ["治愈", "奇幻", "日常"],
    year: "2024",
    region: "日本",
    episodes: 10,
    rating: 9.0,
    status: "已完结",
    tags: ["治愈", "日常", "奇幻", "温情"],
    characters: [
      { name: "小满", cv: "茅野爱衣", role: "主角" },
      { name: "三花", cv: "花泽香菜", role: "邮差猫" },
      { name: "老黑", cv: "大塚明夫", role: "钟表匠" },
    ],
    newsIds: ["n04"],
  },
  {
    id: "a05",
    title: "深海图书馆",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20digital%20illustration%20of%20a%20vast%20underwater%20library%20with%20towering%20bookshelves%20lit%20by%20glowing%20jellyfish%2C%20a%20diver%20girl%20holding%20an%20open%20book%20suspended%20in%20deep%20blue%20water%2C%20cel-shaded%2C%20mysterious%20atmosphere%2C%20poster%20composition%2C%20simple%20deep%20indigo%20background%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=anime-cover-05&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20an%20immense%20underwater%20library%20hall%20illuminated%20by%20bioluminescent%20jellyfish%20and%20floating%20light%20orbs%2C%20sunbeams%20piercing%20deep%20blue%20water%20from%20above%2C%20cel-shaded%2C%20dreamlike%2C%20high%20detail%2C%20no%20text&width=1600&height=760&seq=anime-hero-05&orientation=landscape",
    synopsis:
      "深海中封存着人类所有的书，而唯一能读懂它们的，是忘记了自己名字的潜水员。",
    story:
      "海平面上升百年之后，陆地文献沉入了名为“沉默之海”的深渊。潜水员澪受雇打捞书籍，却在海底发现了一座仍在运转的图书馆。管理员告诉她：这里的每一本书都在等一个真正的读者，而澪正是最后一位。为了找回被海水抹去的文字，也为了找回自己的名字，她一次次潜入更深处的书架，在故事与故事之间打捞人类的记忆。",
    director: "白石道人",
    types: ["奇幻", "剧情", "文艺"],
    year: "2025",
    region: "日本",
    episodes: 13,
    rating: 8.8,
    status: "连载中",
    tags: ["奇幻", "文艺", "海洋", "剧情"],
    characters: [
      { name: "澪", cv: "早见沙织", role: "主角 / 潜水员" },
      { name: "管理员", cv: "井上和彦", role: "图书馆管理者" },
      { name: "灯", cv: "悠木碧", role: "灯塔守望者" },
    ],
    newsIds: ["n06"],
  },
  {
    id: "a06",
    title: "樱花剑客录",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20digital%20illustration%20of%20a%20stoic%20ronin%20in%20a%20flowing%20dark%20kimono%20drawing%20a%20katana%20under%20a%20swirling%20storm%20of%20pink%20cherry%20blossoms%2C%20dramatic%20dynamic%20pose%2C%20cel-shaded%2C%20period%20drama%20poster%20composition%2C%20simple%20warm%20beige%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=anime-cover-06&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20lonely%20samurai%20standing%20on%20a%20wooden%20bridge%20above%20a%20river%20of%20falling%20cherry%20blossoms%20at%20dusk%2C%20distant%20mountain%20ranges%2C%20cel-shaded%2C%20serene%20melancholic%20mood%2C%20high%20detail%2C%20no%20text&width=1600&height=760&seq=anime-hero-06&orientation=landscape",
    synopsis:
      "刀不出鞘的浪人，用十年时间追查一场樱花下的灭门旧案。",
    story:
      "幕末之后，剑客林立之世落幕。曾经的剑术天才玄一郎封刀归隐，只为查明十年前樱丘之变的真相。他化名流浪，带着徒弟小春游走各地，用“不出鞘”的方式化解争端。随着调查深入，他发现当年的凶手竟是自己最敬重的师长。刀与道义的对决、恩义与仇恨的纠缠，最终都将在樱花落下时得到答案。",
    director: "岩本武",
    types: ["动作", "历史", "剧情"],
    year: "2023",
    region: "日本",
    episodes: 26,
    rating: 9.1,
    status: "已完结",
    tags: ["动作", "武士", "历史", "剧情"],
    characters: [
      { name: "玄一郎", cv: "中井和哉", role: "主角 / 浪人" },
      { name: "小春", cv: "上田丽奈", role: "徒弟" },
      { name: "藤堂", cv: "中田让治", role: "师长" },
    ],
    newsIds: ["n09"],
  },
  {
    id: "a07",
    title: "机械之心",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20digital%20illustration%20of%20a%20battle%20mecha%20with%20glowing%20amber%20core%20kneeling%20in%20a%20ruined%20city%2C%20a%20young%20pilot%20in%20an%20open%20cockpit%20holding%20out%20a%20hand%2C%20cel-shaded%2C%20industrial%20sci-fi%20poster%20composition%2C%20simple%20dark%20steel%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=anime-cover-07&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20giant%20mecha%20and%20a%20small%20human%20silhouette%20standing%20before%20a%20vast%20sunset%20horizon%20of%20ruined%20skyscrapers%2C%20dust%20in%20the%20air%2C%20cel-shaded%2C%20epic%20scifi%20mood%2C%20high%20detail%2C%20no%20text&width=1600&height=760&seq=anime-hero-07&orientation=landscape",
    synopsis:
      "被当作兵器制造出来的机械少年，在战场上第一次学会了“心疼”。",
    story:
      "大战结束三十年后，废土上仍游荡着未被销毁的旧时代兵器。少年技师阿尔捡到了一台还能启动的机动装甲，而它的核心是一名拥有自我意识的 AI 少年“九号”。九号没有名字、没有记忆，只会战斗。为了教它理解世界，阿尔带它穿越废土寻找零件与故事。当军方追来要回收兵器时，九号必须自己决定：是成为武器，还是成为一个人。",
    director: "坂本英树",
    types: ["科幻", "机甲", "热血"],
    year: "2024",
    region: "日本",
    episodes: 24,
    rating: 8.7,
    status: "已完结",
    tags: ["科幻", "机甲", "战斗", "成长"],
    characters: [
      { name: "阿尔", cv: "花江夏树", role: "主角 / 技师" },
      { name: "九号", cv: "梶裕贵", role: "机械少年" },
      { name: "莉娜", cv: "佐仓绫音", role: "军方追猎者" },
    ],
    newsIds: ["n06", "n10"],
  },
  {
    id: "a08",
    title: "幻境料理人",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20digital%20illustration%20of%20a%20cheerful%20young%20cook%20flipping%20a%20pan%20of%20glowing%20enchanted%20food%20in%20a%20magical%20kitchen%2C%20floating%20herbs%20and%20sparkles%20around%2C%20warm%20amber%20palette%2C%20cel-shaded%2C%20fantasy%20comedy%20poster%20composition%2C%20simple%20cream%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=anime-cover-08&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20bustling%20magical%20marketplace%20food%20street%20with%20steaming%20stalls%2C%20floating%20lanterns%20and%20colorful%20fantasy%20dishes%2C%20warm%20golden%20lighting%2C%20cel-shaded%2C%20cozy%20fantasy%20mood%2C%20high%20detail%2C%20no%20text&width=1600&height=760&seq=anime-hero-08&orientation=landscape",
    synopsis:
      "能尝出情绪的料理人，在一座魔法都市里用一盘菜化解一个个心结。",
    story:
      "少年厨师阿澈拥有特殊的天赋：他能尝出食材里残留的情绪。凭借这份能力，他在魔法都市的美食街开了一家小小的深夜食堂，客人有失意的冒险者、闹别扭的精灵贵族、以及想念家乡的人类旅人。阿澈用一道道看似普通的家常菜，悄悄解开了他们的心结。料理不只是填饱肚子，更是一句“我懂你”。",
    director: "吉田遥",
    types: ["奇幻", "日常", "美食"],
    year: "2025",
    region: "国内",
    episodes: 12,
    rating: 8.5,
    status: "连载中",
    tags: ["奇幻", "美食", "日常", "治愈"],
    characters: [
      { name: "阿澈", cv: "苏航", role: "主角 / 料理人" },
      { name: "艾莉", cv: "夏语", role: "精灵贵族" },
      { name: "老灶", cv: "黄伯", role: "厨具店老板" },
    ],
    newsIds: ["n02"],
  },
  {
    id: "a09",
    title: "天穹纪元",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20digital%20illustration%20of%20a%20heroic%20youth%20standing%20on%20a%20floating%20island%20reaching%20toward%20a%20colossal%20sky%20citadel%2C%20clouds%20and%20light%20rays%2C%20draconic%20shadows%20above%2C%20cel-shaded%2C%20epic%20fantasy%20poster%20composition%2C%20simple%20sky%20blue%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=anime-cover-09&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20floating%20islands%20chained%20to%20a%20giant%20sky%20citadel%20above%20an%20endless%20sea%20of%20clouds%20at%20sunrise%2C%20winged%20creatures%20gliding%20far%20away%2C%20cel-shaded%2C%20grand%20epic%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1600&height=760&seq=anime-hero-09&orientation=landscape",
    synopsis:
      "天空之上悬浮着神明留下的城邦，而唯一能登顶的，是被大地遗弃的少年。",
    story:
      "传说在世界崩坏前，神明将最后的火种封存在天穹之城。大地被永夜笼罩，人类只能仰望。孤儿出身的凯尔意外获得了一枚会发光的吊坠，那是通往天空的钥匙。他与机械师少女、失忆的龙骑士组成队伍，一路攀爬浮岛、破解古代机关、对抗守门的巨人。当他们终于登上城邦，却发现要拯救大地，必须先学会放手。",
    director: "大森贵洋",
    types: ["奇幻", "冒险", "热血"],
    year: "2024",
    region: "日本",
    episodes: 24,
    rating: 8.9,
    status: "已完结",
    tags: ["奇幻", "冒险", "热血", "史诗"],
    characters: [
      { name: "凯尔", cv: "细谷佳正", role: "主角" },
      { name: "米娅", cv: "内田真礼", role: "机械师" },
      { name: "塞尔", cv: "小野大辅", role: "龙骑士" },
    ],
    newsIds: ["n08"],
  },
  {
    id: "a10",
    title: "甜品侦探社",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20digital%20illustration%20of%20three%20cute%20teen%20detectives%20with%20magnifying%20glasses%20in%20a%20pastel%20bakery%20full%20of%20colorful%20cupcakes%20and%20macarons%2C%20playful%20mood%2C%20cel-shaded%2C%20light%20comedy%20poster%20composition%2C%20simple%20soft%20pink%20cream%20background%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=anime-cover-10&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20bright%20pastel%20patisserie%20interior%20with%20glass%20display%20cases%20of%20cakes%2C%20teens%20investigating%20with%20notebooks%2C%20warm%20sunlight%20through%20large%20windows%2C%20cel-shaded%2C%20cheerful%20mood%2C%20high%20detail%2C%20no%20text&width=1600&height=760&seq=anime-hero-10&orientation=landscape",
    synopsis:
      "开在甜品店二楼的侦探社，专门受理那些“甜到发腻”的小小委托。",
    story:
      "高二学生甜甜继承了外婆留下的甜品店，也顺带继承了二楼那间几乎被遗忘的侦探社。她与擅长算数的同桌、爱八卦的店猫一起，受理校园与街区里的各种小委托：找回丢失的社团经费、查出匿名情书的作者、解开毕业照上的谜题。案件不大，答案却总藏着一点温柔。破案之后，来一份现烤的蛋挞，就是最好的收尾。",
    director: "小林纱耶",
    types: ["日常", "悬疑", "搞笑"],
    year: "2025",
    region: "国内",
    episodes: 12,
    rating: 8.3,
    status: "连载中",
    tags: ["日常", "推理", "校园", "轻松"],
    characters: [
      { name: "甜甜", cv: "米雪", role: "主角 / 店长" },
      { name: "卓然", cv: "陆辰", role: "同桌" },
      { name: "布丁", cv: "猫配声·阿啾", role: "店猫" },
    ],
    newsIds: ["n04", "n07"],
  },
  {
    id: "a11",
    title: "银翼物语",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20digital%20illustration%20of%20a%20girl%20with%20metallic%20feather%20wings%20soaring%20above%20a%20sea%20of%20clouds%20at%20dawn%2C%20wind%20in%20her%20hair%2C%20cel-shaded%2C%20aerial%20adventure%20poster%20composition%2C%20simple%20pale%20blue%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=anime-cover-11&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20fleet%20of%20winged%20gliders%20flying%20between%20towering%20cloud%20pillars%20at%20golden%20hour%2C%20sense%20of%20speed%20and%20freedom%2C%20cel-shaded%2C%20high%20detail%2C%20no%20text&width=1600&height=760&seq=anime-hero-11&orientation=landscape",
    synopsis:
      "在一个重力会不定期翻转的世界里，少年们驾着银翼滑翔机追逐着失踪的姐姐。",
    story:
      "这个世界每隔数年，重力方向就会反转一次，地面变成天空。飞行为此成为生存技能。少年天翔的姐姐是顶尖的滑翔机飞行员，却在一次“大翻转”中失踪。为了找到她，天翔加入了飞行学院，与一群性格各异的同伴学习驾驭银翼。他们在气流与雷暴之间穿行，也逐渐拼凑出姐姐留下的航线图——那是一条通往世界真相的路。",
    director: "河森太一",
    types: ["冒险", "科幻", "热血"],
    year: "2023",
    region: "日本",
    episodes: 26,
    rating: 8.8,
    status: "已完结",
    tags: ["冒险", "科幻", "飞行", "热血"],
    characters: [
      { name: "天翔", cv: "岛崎信长", role: "主角" },
      { name: "露娜", cv: "雨宫天", role: "飞行学院同学" },
      { name: "零式", cv: "津田健次郎", role: "教官" },
    ],
    newsIds: ["n10"],
  },
  {
    id: "a12",
    title: "夏日烟火计划",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20digital%20illustration%20of%20a%20group%20of%20high%20school%20friends%20in%20yukata%20watching%20fireworks%20over%20a%20river%20at%20a%20summer%20festival%2C%20warm%20lantern%20glow%2C%20cel-shaded%2C%20nostalgic%20youth%20poster%20composition%2C%20simple%20deep%20blue%20evening%20background%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=anime-cover-12&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20colorful%20summer%20festival%20street%20with%20food%20stalls%20and%20lanterns%2C%20giant%20fireworks%20blooming%20above%20a%20river%2C%20crowd%20silhouettes%2C%20cel-shaded%2C%20romantic%20summer%20night%2C%20high%20detail%2C%20no%20text&width=1600&height=760&seq=anime-hero-12&orientation=landscape",
    synopsis:
      "毕业前的最后一个夏天，五个好友决定办一场只属于他们的烟火大会。",
    story:
      "高三的夏天，五个人收到消息：镇上的烟火大会因为经费问题要停办了。为了留住这段共同的记忆，他们决定自己筹办一场小型烟火。从申请许可、拉赞助、动手制作烟火，到面对升学与离别的现实，这个夏天充满了争吵、汗水与笑泪。当第一朵烟火在夜空绽开时，他们终于明白，有些光，是留给回忆的。",
    director: "新海遥",
    types: ["青春", "日常", "剧情"],
    year: "2024",
    region: "日本",
    episodes: 12,
    rating: 8.7,
    status: "已完结",
    tags: ["青春", "校园", "日常", "治愈"],
    characters: [
      { name: "遥", cv: "种崎敦美", role: "主角" },
      { name: "健二", cv: "内山昂辉", role: "烟火组长" },
      { name: "美绪", cv: "鬼头明里", role: "策划担当" },
    ],
    newsIds: ["n04", "n09"],
  },
  {
    id: "a13",
    title: "龙语者学院",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20digital%20illustration%20of%20a%20young%20student%20in%20a%20magic%20academy%20uniform%20with%20a%20small%20dragon%20perched%20on%20the%20shoulder%2C%20glowing%20rune%20circle%20beneath%20them%2C%20fantasy%20castle%20background%2C%20cel-shaded%2C%20magic%20school%20poster%20composition%2C%20simple%20purple%20dusk%20gradient%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=anime-cover-13&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20grand%20floating%20magic%20academy%20with%20spires%20and%20bridges%2C%20dragons%20circling%20in%20a%20twilight%20sky%2C%20cel-shaded%2C%20majestic%20fantasy%20mood%2C%20high%20detail%2C%20no%20text&width=1600&height=760&seq=anime-hero-13&orientation=landscape",
    synopsis:
      "在只招收龙语者的学院里，不会说话的少年却听得懂龙的心声。",
    story:
      "龙语者学院每年只录取能听懂龙语的学生，而主角言默偏偏不会说一个字的龙语。但他能真切地“感受”到龙的情绪。在学院里，他被同学当作异类，却意外驯服了学院里最暴躁的古龙。为了证明感受也是一种语言，言默和伙伴们参加了三年一度的龙骑大赛，在天空的角逐中，他逐渐找到了自己与龙之间独一无二的沟通方式。",
    director: "川口敬一郎",
    types: ["奇幻", "校园", "热血"],
    year: "2025",
    region: "日本",
    episodes: 24,
    rating: 8.6,
    status: "连载中",
    tags: ["奇幻", "校园", "龙", "热血"],
    characters: [
      { name: "言默", cv: "村濑步", role: "主角" },
      { name: "菲奥娜", cv: "石川由依", role: "同班同学" },
      { name: "古龙·烬", cv: "麦人", role: "古龙" },
    ],
    newsIds: ["n03"],
  },
  {
    id: "a14",
    title: "时光邮差",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20digital%20illustration%20of%20a%20young%20postman%20in%20a%20vintage%20uniform%20delivering%20a%20glowing%20letter%20in%20a%20misty%20old%20town%20street%20at%20dawn%2C%20clock%20towers%20and%20floating%20numbers%2C%20cel-shaded%2C%20nostalgic%20poster%20composition%2C%20simple%20muted%20sepia%20background%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=anime-cover-14&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20winding%20old%20town%20of%20clocks%20and%20misty%20lanes%20at%20golden%20dawn%2C%20a%20postman%20walking%20with%20a%20lantern%2C%20floating%20glowing%20letters%2C%20cel-shaded%2C%20melancholic%20warm%20mood%2C%20high%20detail%2C%20no%20text&width=1600&height=760&seq=anime-hero-14&orientation=landscape",
    synopsis:
      "能够把信寄回过去的邮差，负责投递那些来不及说出口的话。",
    story:
      "在城市的某个角落，有一家只在凌晨营业的邮局。邮差阿时拥有把信寄往过去的能力，但每封“回信”都会以他忘记一件事为代价。他替悔婚的新人挽回爱情，替失去亲人的孩子传递思念，也替年迈的老人寄出一封迟到了四十年的道歉。随着投递的信越来越多，阿时自己的记忆也逐渐空白。直到有一天，他收到了一封写给自己未来的信。",
    director: "汤浅政弘",
    types: ["剧情", "奇幻", "文艺"],
    year: "2024",
    region: "日本",
    episodes: 10,
    rating: 8.9,
    status: "已完结",
    tags: ["剧情", "奇幻", "治愈", "温情"],
    characters: [
      { name: "阿时", cv: "小林千晃", role: "主角 / 邮差" },
      { name: "老局长", cv: "山路和弘", role: "邮局局长" },
      { name: "小铃", cv: "高桥李依", role: "常客" },
    ],
    newsIds: ["n01", "n05"],
  },
  {
    id: "a15",
    title: "赛博忍者",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20digital%20illustration%20of%20a%20high%20tech%20cyber%20ninja%20with%20a%20glowing%20orange%20visor%20and%20a%20plasma%20blade%20on%20a%20neon%20rooftop%2C%20rain%20and%20holograms%2C%20cel-shaded%2C%20cyberpunk%20action%20poster%20composition%2C%20simple%20dark%20teal%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=anime-cover-15&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20neon%20drenched%20megacity%20at%20night%20with%20flying%20cars%20and%20revolving%20holograms%2C%20a%20lone%20ninja%20silhouette%20on%20a%20rooftop%2C%20cel-shaded%2C%20cyberpunk%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1600&height=760&seq=anime-hero-15&orientation=landscape",
    synopsis:
      "被企业改造身心的暗杀者，在一次任务中捡回了一段本该被删除的童年记忆。",
    story:
      "新东京，义体与数据统治一切。代号“零”的忍者是最顶尖的企业暗杀者，记忆被人为清空，只保留战斗程序。一次任务中，她从目标的大脑里同步到一段熟悉的海边记忆——那是她自己的童年。为了找回被抹去的人生，零背叛了雇主，遭到整个城市安保系统的追杀。在逃亡中，她结识了地下黑客与街头医生，一步步拼回破碎的过去，也向操纵一切的巨型企业宣战。",
    director: "押井守人",
    types: ["科幻", "动作", "赛博朋克"],
    year: "2025",
    region: "日本",
    episodes: 12,
    rating: 8.8,
    status: "连载中",
    tags: ["科幻", "动作", "赛博朋克", "悬疑"],
    characters: [
      { name: "零", cv: "泽城美雪", role: "主角 / 忍者" },
      { name: "白鸦", cv: "三木真一郎", role: "地下黑客" },
      { name: "医生", cv: "朴璐美", role: "街头医生" },
    ],
    newsIds: ["n07", "n10"],
  },
  {
    id: "a16",
    title: "微光之城",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20digital%20illustration%20of%20a%20quiet%20girl%20reading%20on%20a%20rooftop%20overlooking%20a%20coastal%20town%20at%20warm%20sunset%2C%20seagulls%20and%20laundry%20lines%2C%20soft%20gentle%20palette%2C%20cel-shaded%2C%20slice%20of%20life%20poster%20composition%2C%20simple%20peach%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=anime-cover-16&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20seaside%20town%20at%20soft%20twilight%20with%20warm%20window%20lights%2C%20narrow%20streets%20and%20a%20quiet%20harbor%2C%20cel-shaded%2C%20peaceful%20healing%20mood%2C%20high%20detail%2C%20no%20text&width=1600&height=760&seq=anime-hero-16&orientation=landscape",
    synopsis:
      "在一座总在傍晚亮起微光的小城里，每个人都在努力过好平凡的一天。",
    story:
      "微光之城是一座靠海的小镇，白天安静，傍晚家家户户的灯次第亮起，像一片温柔的星海。故事围绕着在小镇长大的女孩小晴展开：她要做的，只是替生病的奶奶看顾那间旧书店，顺便处理一堆鸡毛蒜皮的日常。没有惊天动地的大事件，只有邻里间的关照、偷偷萌芽的喜欢、以及关于未来的小小迷茫。生活或许平淡，但每一道微光都值得被记住。",
    director: "山田尚二郎",
    types: ["日常", "治愈", "剧情"],
    year: "2023",
    region: "国内",
    episodes: 12,
    rating: 8.4,
    status: "已完结",
    tags: ["日常", "治愈", "亲情", "温情"],
    characters: [
      { name: "小晴", cv: "悠木花", role: "主角" },
      { name: "奶奶", cv: "京田尚子", role: "书店主人" },
      { name: "阿澈", cv: "江陵", role: "邻居少年" },
    ],
    newsIds: ["n01"],
  },
];